import { Box } from '@material-ui/core';
import styled from 'styled-components';

export const Divider = styled(Box)`
  width: 100%;
  border-bottom: 1px solid black;
  margin-bottom: 10px;
`;
